import { render } from "./ScrollModel.vue?vue&type=template&id=097a155c&scoped=true"
import script from "./ScrollModel.vue?vue&type=script&lang=js"
export * from "./ScrollModel.vue?vue&type=script&lang=js"

import "./ScrollModel.vue?vue&type=style&index=0&id=097a155c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097a155c"]])

export default __exports__